module.exports = __webpack_public_path__ + "img/Collection.4befd980.png";